import type { OptionMenuItem } from '@getaccept/lib-shared/src/options-menu/types/option-menu-item';
import type { TextMenuState, Form, Field, Table, Text } from '../../types';
import { NodeAlign, TextType } from '../../types/enums';

export const getSelectedAlignItem = (textState: TextMenuState): OptionMenuItem =>
  getAlignTextOptions(textState).find(item => isAlign(item.callback, textState)) ||
  getAlignTextOptions(textState).find(item => item.callback === NodeAlign.Left);

export const getNodeFields = (node: Form | Table | Text): Field[] => node?.fields || [];

export const getActiveTextTypeString = (textState: Partial<TextMenuState>): string => {
  if (textState.heading1) {
    return 'heading-1';
  } else if (textState.heading2) {
    return 'heading-2';
  } else if (textState.subHeading) {
    return 'subheading';
  } else if (textState.label) {
    return 'small-text';
  } else if (textState.paragraph) {
    return 'normal-text';
  } else {
    return 'multiple-styles';
  }
};

export const getAlignTextOptions = (textState: Partial<TextMenuState>): OptionMenuItem[] => [
  {
    icon: 'text-align-left',
    title: 'align-left',
    callback: NodeAlign.Left,
    selected: textState.alignLeft,
  },
  {
    icon: 'text-align-center',
    title: 'align-center',
    callback: NodeAlign.Center,
    selected: textState.alignCenter,
  },
  {
    icon: 'text-align-right',
    title: 'align-right',
    callback: NodeAlign.Right,
    selected: textState.alignRight,
  },
  {
    icon: 'text-align-justify',
    title: 'align-justify',
    callback: NodeAlign.Justify,
    selected: textState.alignJustify,
  },
];

export const isAlign = (value: NodeAlign, textState: Partial<TextMenuState>): boolean => {
  switch (value) {
    case NodeAlign.Left:
      return textState.alignLeft;

    case NodeAlign.Center:
      return textState.alignCenter;

    case NodeAlign.Right:
      return textState.alignRight;

    case NodeAlign.Justify:
      return textState.alignJustify;

    default:
      return false;
  }
};

export const isTextType = (value: TextType, textState: Partial<TextMenuState>): boolean => {
  switch (value) {
    case TextType.Paragraph:
      return textState.paragraph;

    case TextType.Heading1:
      return textState.heading1;

    case TextType.Heading2:
      return textState.heading2;

    case TextType.Subheading:
      return textState.subHeading;

    case TextType.Label:
      return textState.label;

    default:
      return false;
  }
};
